module.exports = "/assets/sqlatch-825286920d63bfe5f418fa2302d74d51.svg";